export default __webpack_public_path__ + "static/media/103.ff5807e2.jpg";